import { useDayPriceStore } from "@/components/Inputs/RangePicker/stores/useDayPriceStore.ts";
import { useHoverStore } from "@/components/Inputs/RangePicker/stores/useHoverStore.ts";
import { formatCurrency } from "@/helpers/formatCurrency.ts";
import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import { memo } from "react";
import { type DayButtonProps } from "react-day-picker";

const formatDayKey = (date: Date): string =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(
    2,
    "0",
  )}`;

export const DayButton = memo((props: DayButtonProps) => {
  const setHoveredDate = useHoverStore((state) => state.setHoveredDate);
  const dayPrices = useDayPriceStore((state) => state.dayPrices);
  const accommodationTypeId = useEngineStore((state) => state.accommodationTypeId);
  const { day, modifiers, children, ...buttonProps } = props;
  const showPrice = !modifiers.outside && !modifiers.disabled && !!accommodationTypeId;

  const price = dayPrices[formatDayKey(day.date)];

  return (
    <button onMouseEnter={() => setHoveredDate(day.date)} {...buttonProps}>
      <span className="rdp-day__number">{children}</span>
      {showPrice && <span className="rdp-day__price">{formatCurrency(price, "EUR", 0, 0)}</span>}
    </button>
  );
});

DayButton.displayName = "DayButton";
